import { ERROR_TYPE } from 'constants/error';

class MessageError extends Error {
  public errorContext;
  constructor(errorMsg: string, errorContext: any) {
    const uuidRegex =
      /:\s[A-Za-z0-9]{10}-[A-Za-z0-9]{4}-[A-Za-z0-9]{4}-[A-Za-z0-9]{4}-[A-Za-z0-9]{12}/g;
    let errLoggedMessage = `${ERROR_TYPE.MESSAGE}: ${errorMsg}.`;
    errLoggedMessage = errLoggedMessage.replace(uuidRegex, '').trim();
    super(errLoggedMessage);
    this.errorContext = errorContext;
  }
  render() {
    return Error;
  }
}

export default MessageError;
